// extracted by mini-css-extract-plugin
module.exports = {"Automotive":"Automotive_Automotive__2TANj"};